(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('DeleteController',DeleteController);

    DeleteController.$inject = ['$state', '$uibModalInstance', 'User', 'Auth'];

    function DeleteController($state, $uibModalInstance, User, Auth) {
        var vm = this;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // this function send delete request to the user.service
        vm.confirm = function () {
            User.deleteRequest(
                function () {
                    Auth.logout();
                    $state.go('login');
                    $uibModalInstance.close(true);
                });
        };

    }
})();
